import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ProgressCard, Spacer, TextCapitalized } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { StyledColumn } from "@qivia/ui/src/designSystem/components/driverAppV2/layout";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  getCardExpensesAsync,
  selectCardExpenses,
  selectCardExpensesStatus,
} from "../../qrCode/menuSlice";
import { selectCardHolderIdentification } from "../../qrCode/vehicleLoginSlice";

export const OperationsLimits = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const cardHolderIdentification = useAppSelector(
    selectCardHolderIdentification,
  );
  const cardExpenses = useAppSelector(selectCardExpenses);
  const cardExpensesStatus = useAppSelector(selectCardExpensesStatus);

  useEffect(() => {
    if (cardExpensesStatus === "idle" && cardHolderIdentification) {
      void dispatch(getCardExpensesAsync({ cardHolderIdentification }));
    }
  }, [cardExpensesStatus, cardHolderIdentification, dispatch]);

  if (!cardExpenses) return null;

  const categoryLimits = cardExpenses.categoryExpenses.flatMap((limit) =>
    limit.typeLimit ? [{ ...limit, typeLimit: limit.typeLimit }] : [],
  );

  if (categoryLimits.length === 0) {
    return (
      <StyledEmpty>
        <TextCapitalized>{t("appV2.operations.limits.empty")}</TextCapitalized>
      </StyledEmpty>
    );
  }

  return (
    <StyledColumn>
      {categoryLimits.map((limit, index) => (
        <StyledColumn key={limit.category}>
          {index > 0 ? <Spacer y={1} /> : null}
          <StyledCategory>
            <TextCapitalized>
              {t(`driverPayment.cardExpenses.type.${limit.category}`)}
            </TextCapitalized>
          </StyledCategory>
          <Spacer y={0.5} />
          <ProgressCard
            period={limit.typeLimit}
            value={limit.expenses}
            max={limit.amountLimit}
            variant="white"
          />
        </StyledColumn>
      ))}
    </StyledColumn>
  );
};

const StyledEmpty = styled.div`
  ${typographies["Body/M"]}
  color: ${colors["colors/text/darkGrey"]};
`;

const StyledCategory = styled.div`
  ${typographies["Body/M"]}
  color: ${colors["colors/text/black"]};
`;
